(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/core/svs-fetch/assets/javascripts/index.js') >= 0) return;  svs.modules.push('/components/core/svs-fetch/assets/javascripts/index.js');


'use strict';

var _svs$core$observabili, _svs$core$config, _svsConfig$tpns;
svs.core.svsFetch = svs.core.svsFetch || {};
const PACKAGE_NAME = 'component:core.svsFetch';
const logger = new svs.core.log.Logger(PACKAGE_NAME);
const {
  provider,
  inject,
  SpanKind
} = (_svs$core$observabili = svs.core.observability) !== null && _svs$core$observabili !== void 0 ? _svs$core$observabili : {};
const {
  validateContentType,
  validateBaseUrl,
  resolveUrl
} = svs.core.svsFetch.helpers;

const svsConfig = (_svs$core$config = svs.core.config) === null || _svs$core$config === void 0 || (_svs$core$config = _svs$core$config.data) === null || _svs$core$config === void 0 ? void 0 : _svs$core$config.svsconfig;
const localBaseUri = "".concat(window.location.origin, "/api");
const isPreviewEnvironment = svsConfig === null || svsConfig === void 0 || (_svsConfig$tpns = svsConfig.tpns) === null || _svsConfig$tpns === void 0 ? void 0 : _svsConfig$tpns.includes('_mr');
let svsFetchBaseUri = localBaseUri;
if (isPreviewEnvironment) {
  svsFetchBaseUri = localBaseUri;
} else if (svsConfig !== null && svsConfig !== void 0 && svsConfig.svsFetchBaseUri) {
  svsFetchBaseUri = svsConfig.svsFetchBaseUri;
}

svs.core.svsFetch.create = function () {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const baseUrl = options.baseUrl || '';
  const timeout = options.timeout || 30000;

  validateBaseUrl(baseUrl);

  const tracer = provider === null || provider === void 0 ? void 0 : provider.getTracer(PACKAGE_NAME);

  return async function svsFetch(url) {
    let requestInit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let resolvedUrl;
    let parsedUrl;
    const isAbsoluteUrl = url.startsWith('http://') || url.startsWith('https://');
    if (isAbsoluteUrl) {
      resolvedUrl = url;
      parsedUrl = new URL(url);
    } else {
      const base = baseUrl || svsFetchBaseUri;
      if (base) {
        ({
          resolvedUrl,
          parsedUrl
        } = resolveUrl(base, url));
      } else {
        resolvedUrl = url;
        parsedUrl = new URL(url, window.location.origin);
      }
    }
    const method = (requestInit.method || 'GET').toUpperCase();

    const headers = new Headers({
      accept: 'application/json'
    });

    if (requestInit.headers) {
      if (requestInit.headers instanceof Headers) {
        requestInit.headers.forEach((value, key) => {
          headers.set(key, value);
        });
      } else {
        Object.entries(requestInit.headers).forEach(_ref => {
          let [key, value] = _ref;
          headers.set(key, value);
        });
      }
    }

    validateContentType(method, headers);

    const span = tracer === null || tracer === void 0 ? void 0 : tracer.startSpan(PACKAGE_NAME, {
      kind: SpanKind === null || SpanKind === void 0 ? void 0 : SpanKind.CLIENT
    });
    if (span) {
      span.setAttribute('http.request.method', method);
      span.setAttribute('url.full', resolvedUrl);
      span.setAttribute('server.address', parsedUrl ? parsedUrl.hostname : resolvedUrl);
    }

    if (inject && span) {
      const traceHeaders = inject({}, span);
      if (traceHeaders.traceparent) {
        headers.set('traceparent', traceHeaders.traceparent);
      }
    }

    const logUrl = parsedUrl ? "".concat(parsedUrl.origin).concat(parsedUrl.pathname) : resolvedUrl;
    logger.debug("".concat(PACKAGE_NAME, ": ").concat(method, " ").concat(logUrl));

    const abortController = new AbortController();
    const timeoutId = setTimeout(() => abortController.abort(), timeout);

    const onAbort = () => abortController.abort();
    if (requestInit.signal) {
      requestInit.signal.addEventListener('abort', onAbort);
    }

    const normalizeHostname = hostname => hostname.replace(/^(local-admin\.|local\.)/, '');
    const isSameOrigin = normalizeHostname(parsedUrl.hostname) === normalizeHostname(window.location.hostname);

    const fetchOptions = {
      method,
      headers,
      signal: abortController.signal,
      credentials: requestInit.credentials || (isSameOrigin ? 'include' : 'same-origin')
    };

    const optionalProps = ['body', 'mode', 'cache', 'redirect', 'referrer', 'referrerPolicy', 'integrity', 'keepalive'];
    optionalProps.forEach(prop => {
      if (requestInit[prop] !== undefined) {
        fetchOptions[prop] = requestInit[prop];
      }
    });
    let response;
    try {
      response = await fetch(resolvedUrl, fetchOptions);
    } catch (err) {
      if (span) {
        span.recordException(err);
        span.setAttribute('http.response.status_code', 0);
        span.end();
      }

      if (err.name === 'AbortError') {
        const msg = "API request timed out after ".concat(timeout, "ms");
        logger.warn(msg);
        const error = new Error(msg);
        error.name = 'AbortError';
        throw error;
      }
      logger.warn("".concat(PACKAGE_NAME, ": Unable to call API. ").concat(err.toString()));
      throw err;
    } finally {
      clearTimeout(timeoutId);
      if (requestInit.signal) {
        requestInit.signal.removeEventListener('abort', onAbort);
      }
    }

    if (span) {
      span.setAttribute('http.response.status_code', response.status);
      span.end();
    }
    logger.debug("".concat(PACKAGE_NAME, " response: ").concat(response.status, " ").concat(method, " ").concat(logUrl));

    return response;
  };
};

 })(window);